import React from "react";
import styled from "styled-components";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../../../components/Backdrop";
import { Media } from "../../../../../components/Media";
import { Blade } from "../../../../../components/Blade";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { BladeContent } from "../../../../../components/BladeContent";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { BladeHeader, BladeHeaderHeading, BladeHeaderTitle, BladeHeaderBody, } from "../../../../../components/BladeHeader";
import { hasVisibleContent } from "../../../../../functional/showBladeHeader";
import { RichText } from "../../../../../components/RichText";
import { GameIconAndLabel } from "./GameIconAndLabel";
import { PlatformIcons } from "../../PlatformIcons";
const _BetaMasthead = ({ header, className, backdrop, children, gameIcon, platformIcons, isFullHeight, ...bladeProps }) => {
    const headerContent = hasVisibleContent(header);
    const { background, foreground } = backdrop || {};
    return (React.createElement(Blade, { className: `${className} ${isFullHeight ? "full-height-masthead" : ""}`, ...bladeProps },
        React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background && React.createElement(Media, { media: background, role: "presentation" })),
            React.createElement(BackdropForeground, null, foreground && React.createElement(Media, { media: foreground, role: "presentation", fit: "height" }))),
        React.createElement("div", { className: "gradient-container" }),
        headerContent && (React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeader, null,
                React.createElement(BladeHeaderHeading, null,
                    React.createElement(GameIconAndLabel, { label: header?.supertitle, gameIcon: gameIcon }),
                    header?.title && (React.createElement(BladeHeaderTitle, null,
                        React.createElement("h2", { className: "beta-masthead-header" }, header.title))),
                    header?.description && (React.createElement(BladeHeaderBody, null,
                        React.createElement(RichText, { ...header.description }))),
                    React.createElement(PlatformIcons, { platformIcons: platformIcons }),
                    children))))));
};
export const BetaMasthead = styled(_BetaMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=BetaMasthead.js.map